module.exports = __webpack_public_path__ + "img/bb.dda62d1a.svg";